<template>
  <div class="seller-detail">
    <div class="breadcrumbs">
      <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    </div>
    <a-spin :spinning="spinning">
      <div class="content-wrap" ref="modalRef">
        <div class="info-wrap">
          <div class="head">Payment Info</div>
          <div class="info">
            <div class="left">
              <div class="text">
                <span>Billing Date: </span>
                <span v-if="detailData.marketplace">{{ moment(detailData.billingDateTimestamp).tz(BILLING_TIME_TZ[detailData.marketplace]).format('YYYY-MM') }}</span>
              </div>
              <div class="text">
                <span>Payment Amount: </span>
                <span>{{ AMAZON_CURRENCY_MAPPER[detailData.marketplace] }}{{ detailData.amount }}</span>
              </div>
              <div class="text" v-if="detailData.status !== 'pending'">
                <span>Seller Paid: </span>
                <span>{{ AMAZON_CURRENCY_MAPPER[detailData.marketplace] }}{{ detailData.paidAmount }}</span>
              </div>
              <div class="text">
                <span>Payment Status: </span>
                <span>{{ FINANCE_SELLER_STATUS_MAP[detailData.status]?.label }}</span>
              </div>
            </div>
            
        
            <artmisads-button  v-if="detailData.status === 'pending'" @click="() => setShowConfirmModal(true)"
              type="primary" size="middle">Confirm</artmisads-button>
          
           
          </div>
        </div>
        <div class="details">
          <div class="head">
            <span>Details</span>
            <div class="right">
              <artmisads-button-special  @click="exportData" :isSquare="true"
            type="primary" >Export</artmisads-button-special>
            <fileBar :params="params" :getList="getData" :exportsNum="exportsNum" :id="params.id"
              v-if="detailData.status !== 'pending'" />
            </div>
          
          </div>
          <div class="operation">
            <div class="left">
              <div class="item">
                <span>Seller Name</span>
                <artmisads-select show-search v-model:value="params.sellerId" :options="sellerOptions"
                  @search="searchSeller" :show-arrow="false" :filter-option="false" @change="handleChangeSeller"
                  :not-found-content="null" placeholder="All" allowClear />
              </div>
              <div class="item" v-if="detailData.status !== 'pending'">
                <span>Status</span>
                <artmisads-select v-model:value="params.detailStatus" :filter-option="false" :not-found-content="null"
                  :options="FINANCE_PAYMENT_DETAIL_STATUS" placeholder="All" />
              </div>
              <div class="item">
                <span>Brand</span>
                <artmisads-select :show-search="!params.sellerId" v-model:value="params.brandId" :options="brandOptions"
                  @search="searchBrand" :show-arrow="false" :filter-option="false" :not-found-content="null"
                  placeholder="All" allowClear />
              </div>
              <div class="item">
                <span>Invoice No.</span>
                <artmisads-input v-model:value="params.invoiceNo" size="middle" />
              </div>
              <div class="item">
                <span>PaymentID</span>
                <artmisads-input v-model:value="params.billingId" size="middle" />
              </div>
            </div>
            <div class="right">
              <artmisads-button @click="() => getFinanceSellerBillingsDetailsList(1)" :isSquare="true" type="primary"
                size="middle">Search</artmisads-button>
              <artmisads-button @click="() => setParams()" type="text" :isSquare="true"
                size="middle">Reset</artmisads-button>
              <a-popconfirm title="Are you sure to send email to all sellers?" ok-text="Yes" cancel-text="No" class=""
                @confirm="postEmailToAll" :getPopupContainer="() => modalRef" :overlayStyle="{ width: '300px' }">
                <artmisads-button type="text" :isSquare="true" size="middle" :disabled="detailData.isAllEmailSent">Email
                  to All</artmisads-button>
              </a-popconfirm>
            </div>
          </div>
        </div>
        <div class="table">
          <sellerTable :params="params" :dataList="list" :setParams="setParams"
            :getList="getFinanceSellerBillingsDetailsList" :listTotal="listTotal" :status="detailData.status"
            :setShowPaymentModal="setShowPaymentModal"
            :setShowPaymentDetailModal="setShowPaymentDetailModal"
            :postEmail="postEmail" />
        </div>
      </div>
    </a-spin>
    <paymentModal :showPaymentModal="showPaymentModal" :billingId="billingId" :setShowPaymentModal="setShowPaymentModal" v-if="billingId && showPaymentModal" />
    <paymentDetailModal  :billingId="billingId" :setShowPaymentDetailModal="setShowPaymentDetailModal" v-if="billingId && showPaymentDetailModal" />
    <manualDetailModal  :detailData="detailData" :billingId="billingId" :setShowPaymentDetailModal="setShowPaymentDetailModal" v-if="billingId && showManualDetailModal" />
    <artmisads-modal v-model:open="showConfirmModal" :width="500" title="Payment Confirm?" okText="Confirm"
      @ok="onChangeStatus">
      <div class="active-product">
        <div class="title-ext">
          Are you sure to send payments to all sellers?
        </div>
      </div>
    </artmisads-modal>
  </div>
</template>
<script setup>
import moment from 'moment';
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import { financeApi } from "~/server/operator/finance";
import { publisherAdminApi } from '~/server/index'
import breadcrumbs from "../../../breadcrumbs.vue";
import sellerTable from './sellerTable';
import fileBar from './fileBar';
import paymentModal from './paymentModal';
import paymentDetailModal from './paymentDetailModal';
import { useRoute } from 'vue-router';
import { AMAZON_CURRENCY_MAPPER, BILLING_TIME_TZ } from '~/contants/common';
import { FINANCE_SELLER_STATUS_MAP, FINANCE_SELLER_STATUS, FINANCE_PAYMENT_DETAIL_STATUS, FINANCE_SELLER_PAYMENT_STATUS } from '~/contants/operator';
import { message } from 'ant-design-vue';
import manualDetailModal from './manualDetailModal';
const params = ref({
  id: '',
  page: 1,
  size: 10,
  brandId: null,
  sellerId: null,
  invoiceNo: null,
  billingId: null,
  detailStatus: null
})
const modalRef = ref();
const brandOptions = ref([]);
const billingId = ref('');
const showPaymentDetailModal = ref(false)
const showPaymentModal = ref(false)
const showConfirmModal = ref(false);
const showManualDetailModal = ref(false);
const listTotal = ref(0);
const list = ref([]);
const route = useRoute();
const sellerOptions = ref([]);
const spinning = ref(true);
const detailData = ref({});
const breadcrumbsData = computed(() => {
  const data = {
    title: 'Payment Details',
    links: [
      {
        name: 'Home',
        path: '/operator/users'
      },
      {
        name: 'Payment',
        path: '/operator/finance/payments'
      },
      {
        name: 'Payment Details',
        path: `/operator/finance/payments/seller-detail/${params.value.id}`
      },
    ]
  }
  return data;
})

const setShowPaymentDetailModal = (status, billingIdData = '',type = '') => {
  billingId.value = billingIdData;
  if(type === 'MANUAL'){
    showManualDetailModal.value = status;
  }else{
    showPaymentDetailModal.value = status;
  }
}

const setShowPaymentModal = (status, reload, billingIdData = '') => {
  billingId.value = billingIdData;
  showPaymentModal.value = status;
  if (reload) {
    getFinanceSellerBillingsDetailsList();
    getFinanceSellerDetailInfo();
  }
}

const postEmailToAll = async billingId => {
  spinning.value = true;
  const params = {
    marketplace: detailData.value.marketplace,
    billingDateTimestamp: detailData.value.billingDateTimestamp
  }
  const res = await financeApi.financeSellerBillingsDetailsNotifyEmailToAll(params);
  if (res === null) {
    message.success('Success');
    getFinanceSellerDetailInfo();
    getFinanceSellerBillingsDetailsList();
  }
  spinning.value = false;
}

const postEmail = async billingId => {
  spinning.value = true;
  const res = await financeApi.financeSellerBillingsDetailsNotifyEmail({ billingId });
  if (res === null) {
    message.success('Success');
    getFinanceSellerBillingsDetailsList();
  }
  spinning.value = false;
}

const getData = () => {
  getFinanceSellerDetailInfo();
  getFinanceSellerBillingsDetailsList();
}

const setParams = data => {
  if (data) {
    params.value = data;
  } else {
    params.value.page = 1;
    params.value.brandId = null;
    params.value.sellerId = null;
    params.value.invoiceNo = null;
    params.value.detailStatus = null;
    params.value.billingId = null;
    getFinanceSellerBillingsDetailsList();
  }
}

const handleChangeSeller = (id, record) => {
  const { sellerBrands = [] } = record;
  if (sellerBrands.length) {
    brandOptions.value = sellerBrands;
    params.value.brandId = '';
  }
}

const searchBrand = async keyword => {
  const params = {
    keyword,
    marketplace: detailData.value.marketplace
  };
  let data = await publisherAdminApi.searchBrand(params);
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id;
      item.label = item.amazonBrandName;
      return item;
    })
    brandOptions.value = data;
  }
}

const setShowConfirmModal = status => {
  showConfirmModal.value = status;
}

const onChangeStatus = async () => {
  spinning.value = true;
  const res = await financeApi.financeSellerBillingsConfirm({ id: params.value.id });
  if (res === null) {
    message.success('Success');
    showConfirmModal.value = false;
    getFinanceSellerDetailInfo();
    getFinanceSellerBillingsDetailsList();
  }
  spinning.value = false;
}

const searchSeller = async keyword => {
  let res, paramsData = { keyword, marketplace: detailData.value.marketplace };
  res = await publisherAdminApi.searchSeller(paramsData);
  if (res) {
    sellerOptions.value = res.map(item => {
      item.value = item.id;
      item.label = item.sellerName;
      item.sellerBrands = item.sellerBrands?.map(i => {
        i.value = i.id;
        i.label = i.amazonBrandName;
        return i;
      })
      return item;
    })
  }
}

const getFinanceSellerBillingsDetailsList = async (page) => {
  spinning.value = true;

  if (page) {
    params.value.page = page;
  }

  const res = await financeApi.getFinanceSellerBillingsDetailsList(params.value);
  const { data } = res;
  if (res && res.data) {
    listTotal.value = res.total;
    list.value = res.data;
  }
  spinning.value = false;
}

const getFinanceSellerDetailInfo = async () => {
  spinning.value = true;
  const res = await financeApi.getFinanceSellerDetailInfo(params.value);
  if (res) {
    detailData.value = res;
  }
  spinning.value = false;
}
const exportData = () => {
  let time = moment().format("YYYY-MM-DD");
  publisherAdminApi.exportSeller({
    qs: {
      id: params.value.id
    },
    fileName: `seller_payment_info_${time}.csv`,
    platform: 'operator'
  })
}
onBeforeMount(() => {
  const { id } = route.params;
  if (id) {
    params.value.id = id;
  }
})

onMounted(() => {
  getFinanceSellerDetailInfo();
  getFinanceSellerBillingsDetailsList();
})

</script>
<style lang="less" scoped>
.seller-detail {
  padding: 0 16px 16px;

  .file-bar {
    padding: 0!important;
  }

  .content-wrap {
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);
    padding: 16px;
  }

  .info-wrap {
    .head {
      height: 28px;
      color: var(--dark-1);
      font-weight: 600;
      font-size: 20px;
      letter-spacing: 0.5px;
      line-height: 28px;
      padding-bottom: 8px;
  
    }

    .info {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;

      .left {
        display: flex;

        .text {
          margin-right: 30px;

          >span:last-child {
            color: var(--dark-1);
            font-weight: 600;
            font-size: 14px;
            letter-spacing: 0.3px;
            margin-left: 4px;
          }
        }
      }
    }
  }

  .details {
    margin-top: 20px;

    .head {
      display: flex;
      justify-content: space-between;
      .right{
        display: flex;
        gap: 10px;
        align-items: center;
      }
      >span {
        height: 28px;
        color: var(--dark-1);
        font-weight: 600;
        font-size: 20px;
        letter-spacing: 0.5px;
        line-height: 28px;
        padding-bottom: 8px;
      }
    }

    .operation {
      margin-top: 20px;

      .left {
        gap: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item {
          flex: 1;
          display: flex;
          align-items: center;

          >span {
            font-size: 13px;
            font-weight: 500;
            line-height: 18px;
            margin-right: 8px;
            color: var(--dark-2);
            letter-spacing: 0.3px;
          }

          >div,
          >.ant-input {
            flex: 1;
          }
        }
      }

      .right {
        display: flex;
        margin-top: 20px;
        align-items: center;
        justify-content: flex-end;
      }

      button {
        margin-left: 8px;
        align-self: flex-end;
      }
    }
  }
}

.table {
  margin-top: 20px;
}
</style>